<template>
<section :class="[block.class, {'half-padding-top': block.half_padding_top}, {'half-padding-bottom': block.half_padding_bottom}, 'section', block.bgcolour]" :id="block.anchor ? block.anchor : ('block-' + block.id)">
    <div class="container">
        <div class="columns is-variable is-6 is-multiline">
            <div class="column is-4">
                <h2 v-if="block.title" :class="['title', block.title_colour]">{{block.title}}</h2>
            </div>
            <div class="column is-8">
                <div class="content" ref="content" v-html="block.content"></div>
                <div class="cta" v-if="block.cta && block.cta.button">
                    <CTALink :link_data="block.cta" />
                </div>
            </div>
            <div class="column is-12" v-if="block.image">
                <figure>
                    <img :alt="block.image.title" :src="block.image.url" />
                    <figcaption v-if="block.image.copyright">{{block.image.copyright}}</figcaption>
                </figure>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import BlockCommons from '../../mixins/BlockCommons';
export default {
    name        :   'TitleContentCTAImageBlock',
    mixins      :   [ BlockCommons ],
    mounted() {
        this.$nextTick().then(() => {
            if (this.$refs.content) {
                this.HandleContentedLinks(this.$refs.content, this)
            }
        })
    },
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/modules/TitleContentCTAImageBlock.vue